import { Page } from "shared/react";
import { COMMENTS_MAX } from "shared/schema";
import { EmbedMarkup } from "../misc/EmbedMarkup.js";
import { useItem } from "../util/db.js";
import { CommentHeader } from "./Comment.js";
import { CommentList } from "./CommentList.js";

export function CommentPage({ id }: { id: string }): React.ReactElement {
	const comment = useItem("comment", id);
	const { target, content } = comment.data;
	return (
		<Page title="Comment">
			<article>
				<CommentHeader {...comment.data} />
				<section className="space-xsmall">
					<EmbedMarkup>{content}</EmbedMarkup>
				</section>
			</article>
			<hr />
			<CommentList //
				query={{
					target,
					thread: id,
					$order: "!date",
					$limit: COMMENTS_MAX,
				}}
				mods="flex-column flex-reverse"
			/>
		</Page>
	);
}
